import { Link } from "react-router-dom";

import "../../styles/_carrier-links.scss";

const ReferenceToolsPage = () => {
  return (
    <div id="reference-tools" style={{ paddingBottom: 0 }}>
      <h1 className="mb-5">Reference Tools</h1>
      <div className="ref-tools-label">
        <Link to="/reference-tools/payment" className="ref-tools-link">
          <img src="/content/images/icon-premium_payment_info.svg" alt="" />
          <div className="link-name">
            <span>Premium Payment Info</span>
            <img src="/content/images/cheveron-right-dark.svg" alt="" />
          </div>
        </Link>
        <Link to="/reference-tools/carrier" className="ref-tools-link">
          <img src="/content/images/icon-carrier_claim_info.svg" alt="" />
          <div className="link-name">
            <span>Carrier Claim Info</span>{" "}
            <img src="/content/images/cheveron-right-dark.svg" alt="" />
          </div>
        </Link>
        <Link to="/reference-tools/acord" className="ref-tools-link">
          <img src="/content/images/icon-accord_application.svg" alt="" />
          <div className="link-name">
            <span>ACORD Applications</span>{" "}
            <img src="/content/images/cheveron-right-dark.svg" alt="" />
          </div>
        </Link>
        <Link to="/reference-tools/bor" className="ref-tools-link">
          <img src="/content/images/icon-bor_request.svg" alt="" />
          <div className="link-name">
            <span>BOR Requests</span>{" "}
            <img src="/content/images/cheveron-right-dark.svg" alt="" />
          </div>
        </Link>
        <Link to="/reference-tools/direct-carrier" className="ref-tools-link">
          <img src="/content/images/icon-carrier_servicing.svg" alt="" />
          <div className="link-name">
            <span>Direct Carrier Servicing</span>{" "}
            <img src="/content/images/cheveron-right-dark.svg" alt="" />
          </div>
        </Link>
        <Link to="/reference-tools/direct-carrier-links" className="ref-tools-link">
          <img src="/content/images/icon-direct_carrier_links.svg" alt="" />
          <div className="link-name">
            <span>Direct Carrier Links</span>{" "}
            <img src="/content/images/cheveron-right-dark.svg" alt="" />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default ReferenceToolsPage;
